import { Route, Switch, Redirect } from 'react-router-dom'
import { KeepAlive } from 'react-activation'

import Welcome from '../views/Welcome'
import SupplierManagement from '../views/SupplierManagement'
import ActivityGroup from '../views/Activity/Group/index.js'
import EditActivityGroup from '../views/Activity/Group/components/editActivityGroup'
import DetailActivityGroup from '../views/Activity/Group/components/detailActivityGroup'
import GoodsList from '../views/Activity/Group/components/goodsList'
import OrderList from '../views/Order/OrderList/index.js'
import AfterSale from '../views/Order/AfterSale/index.js'
import Payment from '../views/Order/Payment/index.js'
import PaymentList from '../views/Order/Payment/list.js'
import Inventory from '../views/Inventory'
import Virtual from '../views/Inventory/virtual'
import VirtualHistory from '../views/Inventory/components/HistoryList'
import EditVirtual from '../views/Inventory/components/EditVirtual'
import InventoryCheckSheet from '../views/Inventory/CheckSheet'
import Purchase from '../views/Purchase'
import Brand from '../views/Product/Brand'
import Package from '../views/Product/Package'
import Area from '../views/Product/Area'
import Category from '../views/Product/Category'
import ProductCreate from '../views/Product/Create'
import ProductEdit from '../views/Product/Edit'
import ProductDetail from '../views/Product/Detail'
import ProductMerchant from '../views/Product/Merchant'
import ProductStore from '../views/Product/Store'
import ProductPriceManagement from '../views/Product/Price'
import ProductPriceAudit from '../views/Product/Price/audit.js'
import InventoryStockIn from '../views/Inventory/StockIn'
import InventoryStockOut from '../views/Inventory/StockOut'
import ProductTransfers from '../views/Inventory/ProductTransfers'
import AddProductTransfers from '../views/Inventory/AddProductTransfers'

import RoleList from '../views/Role/List'
import UserList from '../views/User/List'
import StoreSalesReport from '../views/Report/StoreSalesReport'
import OrderShipments from '../views/Order/OrderShipments'
import OrderSend from '../views/Order/OrderSend'
import OrderDetail from '../views/Order/OrderDetail'

import HomeMall from "../views/MallManagement/HomeMall";
import VajraDistrict from "../views/MallManagement/VajraDistrict";
import Advertisement from "../views/MallManagement/Advertisement";
import FreeShipping from "../views/MallManagement/FreeShipping";
// 专区管理
import MallZone from "../views/MallManagement/MallZone";
import MallZoneCreate from "../views/MallManagement/MallZone/Create";
import MallZoneEdit from "../views/MallManagement/MallZone/Edit";
import MallZoneDetail from "../views/MallManagement/MallZone/Detail";
// 自提点管理
import MallSelfDelivery from "../views/MallManagement/MallSelfDelivery";

/**
 * 缓存路由：Route 匹配时用 KeepAlive 包裹组件，保留状态
 */
const CacheRoute = ({ path, exact, component: Component }) => (
  <Route
    path={path}
    exact={exact}
    render={(routeProps) => (
      <KeepAlive id={path} name={path}>
        <Component {...routeProps} />
      </KeepAlive>
    )}
  />
)

const MainContent = props => {
  return (
    <Switch>
      {console.log('TODO:这里是路由查看：MainContent.js')}

      {/* 欢迎页 - 不缓存 */}
      <Route path='/' exact component={Welcome} />

      {/* ====== 列表页 - 使用 CacheRoute 缓存 ====== */}
      <CacheRoute path='/supplier/page' exact component={SupplierManagement} />
      <CacheRoute path='/activity/group/search' exact component={ActivityGroup} />

      {/* 库存 */}
      <CacheRoute path='/inventory/stock/list/real' exact component={Inventory} />
      <CacheRoute path='/inventory/stock/list/virtual' exact component={Virtual} />
      <CacheRoute path='/inventory/stock/list/virtual/history' exact component={VirtualHistory} />
      <CacheRoute path='/inventory/check-sheet/list' exact component={InventoryCheckSheet} />
      <CacheRoute path='/inventory/stock-in/list' exact component={InventoryStockIn} />
      <CacheRoute path='/inventory/stock-out/list' exact component={InventoryStockOut} />
      <CacheRoute path='/inventory/allocation' exact component={ProductTransfers} />

      {/* 采购 */}
      <CacheRoute path='/purchase-order' exact component={Purchase} />

      {/* 订单 */}
      <CacheRoute path='/order/list' exact component={OrderList} />
      <CacheRoute path='/after-sale/list' exact component={AfterSale} />
      <CacheRoute path='/payin/daily-payin/list' exact component={Payment} />
      <CacheRoute path='/payin/payin-slip/item/list' exact component={PaymentList} />
      <CacheRoute path='/order-delivery/list' exact component={OrderShipments} />

      {/* 商品 */}
      <CacheRoute path='/brand/page' exact component={Brand} />
      <CacheRoute path='/package-unit/page' exact component={Package} />
      <CacheRoute path='/area/page' exact component={Area} />
      <CacheRoute path='/category/page' exact component={Category} />
      <CacheRoute path='/product/merchant-product/list' exact component={ProductMerchant} />
      <CacheRoute path='/product/store-product/page' exact component={ProductStore} />
      <CacheRoute path='/product/price/page' exact component={ProductPriceManagement} />
      <CacheRoute path='/product/price-adjust/page' exact component={ProductPriceAudit} />

      {/* 权限 */}
      <CacheRoute path="/auth/role/list" exact component={RoleList} />
      <CacheRoute path="/auth/user/list" exact component={UserList} />

      {/* 报表 */}
      <CacheRoute path="/report/product-sale/list" exact component={StoreSalesReport} />

      {/* 商城管理 */}
      <CacheRoute path='/mallPageProduct/list' exact component={HomeMall} />
      <CacheRoute path='/mallPageGrideMenu/list' exact component={VajraDistrict} />
      <CacheRoute path='/mallPageBanner/list' exact component={Advertisement} />
      <CacheRoute path='/freight' exact component={FreeShipping} />
      <CacheRoute path='/mallZone/list' exact component={MallZone} />
      <CacheRoute path='/mallSelfDelivery/list' exact component={MallSelfDelivery} />

      {/* ====== 非列表页 - 不缓存 ====== */}
      {/* 活动 - 编辑/详情 */}
      <Route path='/activity/group/edit' exact component={EditActivityGroup} />
      <Route path='/activity/group/detail' exact component={DetailActivityGroup} />
      <Route path='/activity/group/goodList' exact component={GoodsList} />

      {/* 库存 - 编辑/调拨新增 */}
      <Route path='/inventory/stock/list/virtual/edit' exact component={EditVirtual} />
      <Route path='/inventory/product-transfers/edit' exact component={AddProductTransfers} />

      {/* 订单 - 发货/详情 */}
      <Route path='/order-delivery/send' exact component={OrderSend} />
      <Route path='/order-delivery/detail' exact component={OrderDetail} />

      {/* 商品 - 创建/编辑/详情 */}
      <Route path='/product/create' exact component={ProductCreate} />
      <Route path='/product/edit' exact component={ProductEdit} />
      <Route path='/product/detail' exact component={ProductDetail} />
      <Route path='/product/store-product/create' exact component={ProductCreate} />
      <Route path='/product/store-product/edit' exact component={ProductEdit} />
      <Route path='/product/store-product/detail' exact component={ProductDetail} />

      {/* 专区 - 创建/编辑/详情 */}
      <Route path='/mallZone/create' exact component={MallZoneCreate} />
      <Route path='/mallZone/edit' exact component={MallZoneEdit} />
      <Route path='/mallZone/detail' exact component={MallZoneDetail} />

      {/* 重定向 */}
      <Redirect from='/order' exact to='/order/list' />
      <Redirect from='/after-sale' exact to='/after-sale/list' />
    </Switch>
  )
}

export default MainContent
